"use client";

import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

const FAQ: React.FC = () => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "Is the PDF beginner-friendly?",
      answer: "Yes. No jargon. No complicated analytics. Just what works."
    },
    {
      question: "Will this still work if my English is not perfect?",
      answer: "Of course — mine isn't. I sound like Sofía Vergara sometimes. It still works. Authenticity performs."
    },
    {
      question: "What if I'm camera-shy?",
      answer: "You don't need video to grow. But if you want to, I explain how I started without overthinking."
    },
    {
      question: "How is the file delivered?",
      answer: "Right after payment, you get an automatic email with the PDF."
    },
    {
      question: "Do you admit refunds?",
      answer: "No. This is a digital product delivered instantly."
    },
    {
      question: "Can I use PayPal?",
      answer: (
        <span>
          Yes. You can pay directly via
          {" "}
          <a
            href="https://paypal.me/elianajordan"
            className="text-cyan-400 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            paypal.me/elianajordan
          </a>
          . Once done, please email me to{" "}
          <a
            href="mailto:peerquik@hotmail.com"
            className="text-cyan-400 hover:underline"
          >
            peerquik@hotmail.com
          </a>{" "}
          so we can send you the ebook.
        </span>
      )
    }
  ];

  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
          FAQ
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-900 rounded-lg border border-cyan-400/20">
              <button
                onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left"
              >
                <span className="font-semibold text-lg pr-4">{faq.question}</span>
                {expandedIndex === index ? (
                  <ChevronUp className="text-cyan-400 flex-shrink-0" />
                ) : (
                  <ChevronDown className="text-cyan-400 flex-shrink-0" />
                )}
              </button>
              {expandedIndex === index && (
                <div className="px-6 pb-6 text-gray-300">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;